import { useState, useEffect, Suspense, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import ResultPage from '@/container/ResultPage';
import ChartDrawer from '@/container/ChartDrawer';

import PageLoader from '@/components/PageLoader';
import SelectCustom from '@/components/SelectCustom';
import ButtonSimple from '@/components/ButtonSimple';
import { PageTitle } from '@/components/uiPart';
import { logHelper } from '@/utils';

import { useGetChartDataByKpiQuery } from '@/services/service';
import { SESSION_LIST, YEAR_LIST, YearToBiennium } from '@/utils/constants';

const KpiDetails = () => {

  const TAG: string = "KpiDetails: ";
  const { id } = useParams();
  const navigate = useNavigate();

  const [isError, setIsError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const [validatedKpiId, setValidatedKpiId] = useState<number | null>(null);
  const [session, setSession] = useState<string>(SESSION_LIST[0]?.value || "");
  const [year, setYear] = useState<string>("2025");

  const [allGraphData, setAllGraphData] = useState<any>([]);

  const returnGraphUI = useCallback(() => {
    return <ChartDrawer graphData={allGraphData} />
  }, [allGraphData])

  useEffect(() => {
    validateUrlId(id);
  }, [id]);



  const {
    data: chartData,
    isLoading: isChartDataLoading,
    isError: isChartDataError,
    error: chartDataError,
    isFetching: isChartDataFetching,
  } = useGetChartDataByKpiQuery(validatedKpiId?.toString() || "", session, year, ...(YearToBiennium(year).biennium.split(",") as [string, string])  );

  function validateUrlId(id: any) {
    if (id === undefined || id === null || id === '' || id === 'undefined' || id === 'null') {
      setIsError("No data in the url");
      setLoading(false);
    } else {
      validateEnquiry(id);
    }
  }

  async function validateEnquiry(kpiId: any) {
    logHelper(TAG, " ====> validateEnquiry got called with id ", kpiId);

    const kpiIdNum: number = parseInt(kpiId);
    if (isNaN(kpiIdNum)) {
      setIsError("Invalid KPI ID");
      setLoading(false);
      return;
    }
    logHelper(TAG, " ====> kpiIdNum parsed ", kpiIdNum);
    setValidatedKpiId(kpiIdNum);

  }

  useEffect(() => {


    // if (isChartDataLoading == true) {
    //   setLoading(true);
    // }


    if (isChartDataLoading == false && isChartDataError == true) {
      logHelper(TAG, " chartDataError ", chartDataError);
      setIsError("Something went wrong while fetching the data");
      setLoading(false);
    }

    if (isChartDataLoading == false && isChartDataError == false && chartData?.data?.length == 0) {
      setIsError("No data found");
      setLoading(false);
    }

    if (isChartDataLoading == false && isChartDataError == false && chartData) {

      // logHelper(TAG, " resposne data ", chartData);  

      if (chartData.data.statusCode === 500) {
        setIsError("Something went wrong while fetching the data");
        setLoading(false);
        return;
      }

      setAllGraphData(chartData?.data);
      setLoading(false);
    }

  }, [isChartDataLoading, isChartDataError]);


  // logHelper(TAG, " ====> isChartDataLoading ", isChartDataLoading);
  logHelper(TAG, " ====> allGraphData ", allGraphData);
  // logHelper(TAG, " ====> isChartDataFetching ", isChartDataFetching);


  if (isError) {
    return (
      <Suspense fallback={<PageLoader message="Loading..." />}>
        <ResultPage
          status="error"
          title="Something went wrong"
          subTitle={isError}
        />
      </Suspense>
    );
  }

  if (loading || validatedKpiId === null || allGraphData.length == 0 || isChartDataLoading == true || isChartDataFetching == true) {
    return <PageLoader message="Loading..." />;
  }



  return (
    <div className="flex flex-1 h-max-full flex-col" >

      <div className="flex items-center justify-between">
        <div>
          <PageTitle title={allGraphData?.[0]?.kpi_name} />
        </div>

        <div className="">
          <ButtonSimple onClick={() => { navigate("/view-charts") }}>View All Charts</ButtonSimple>
        </div>
      </div>


      <div className="mt-4">

        <div className="flex items-center gap-2 my-4 ">
          <label>Period: </label>

          <div className="w-[200px]">
            <SelectCustom
              options={SESSION_LIST}
              onChange={(value: any) => { setSession(value) }}
              value={session}
              placeholder="Session"
              size="small"
            />
          </div>

          <div className="w-[200px]">
            <SelectCustom
              options={YEAR_LIST}
              onChange={(value: any) => { setYear(value) }}
              value={year}
              placeholder="Year"
              size="small"
            />
          </div>

        </div>

        {/* {allGraphData && allGraphData.length > 0 && (
          <ChartDrawer
            graphData={allGraphData}
          />
        )} */}

        {returnGraphUI()}
      </div>

    </div>
  );
};

export default KpiDetails;